<template>
  <div class="ta-page">
    <!-- 共用头部导航栏 -->
    <header-nav></header-nav>

    <div class="ta-root" :class="{ 'scene-mode': viewMode === 'scene' }">
    <!-- ============ 华丽封面（闭合状态） ============ -->
    <div
      v-if="viewMode === 'book'"
      class="cover-closed"
      :class="{ opening: isOpen }"
      @click="openBook"
    >
      <div class="cover-float">
        <div class="cover-art">
          <div class="cover-frame"></div>
          <svg class="cover-corner" viewBox="0 0 120 120" aria-hidden="true">
            <g fill="none" stroke="rgba(255,214,150,.75)" stroke-width="2">
              <path d="M14,120 V40 Q14,14 40,14 H120" />
              <path d="M14,120 V40 Q14,14 40,14 H120" transform="translate(0,0)" opacity="0" />
              <circle cx="14" cy="120" r="5" fill="rgba(255,214,150,.9)" stroke="none" />
              <circle cx="14" cy="70" r="3" fill="rgba(255,214,150,.8)" stroke="none" />
              <circle cx="70" cy="14" r="3" fill="rgba(255,214,150,.8)" stroke="none" />
            </g>
            <g fill="none" stroke="rgba(255,214,150,.75)" stroke-width="2">
              <path d="M106,0 V80 Q106,106 80,106 H0" />
              <circle cx="106" cy="0" r="5" fill="rgba(255,214,150,.9)" stroke="none" />
              <circle cx="106" cy="50" r="3" fill="rgba(255,214,150,.8)" stroke="none" />
              <circle cx="50" cy="106" r="3" fill="rgba(255,214,150,.8)" stroke="none" />
            </g>
          </svg>

          <!-- 中央魔法徽记 -->
          <div class="cover-emblem">
            <svg viewBox="0 0 240 240" aria-hidden="true">
              <defs>
                <radialGradient id="cg-glow" cx="0.5" cy="0.42" r="0.6">
                  <stop offset="0" stop-color="rgba(255,226,150,.55)" />
                  <stop offset="1" stop-color="rgba(255,226,150,0)" />
                </radialGradient>
              </defs>
              <circle cx="120" cy="120" r="104" fill="url(#cg-glow)" />
              <circle cx="120" cy="120" r="88" fill="none" stroke="rgba(255,217,138,.5)" stroke-width="1.5" stroke-dasharray="3 7" />
              <circle cx="120" cy="120" r="80" fill="none" stroke="rgba(255,217,138,.28)" stroke-width="1" />
              <path d="M120,132 C98,106 72,98 50,102 C60,124 86,134 120,136 Z" fill="rgba(255,240,210,.9)" />
              <path d="M120,132 C142,106 168,98 190,102 C180,124 154,134 120,136 Z" fill="rgba(255,240,210,.9)" />
              <path d="M58,152 L58,108 Q90,94 119,104 L119,158 Q90,146 58,152 Z" fill="#ffd98a" />
              <path d="M182,152 L182,108 Q150,94 121,104 L121,158 Q150,146 182,152 Z" fill="#ffe6b4" />
              <path d="M58,152 L58,108 Q90,94 119,104" fill="none" stroke="#d9a25a" stroke-width="1.6" />
              <path d="M182,152 L182,108 Q150,94 121,104" fill="none" stroke="#d9a25a" stroke-width="1.6" />
              <path d="M120,86 C120,78 112,72 105,76 C99,80 99,88 105,92 L120,102 L135,92 C141,88 141,80 135,76 C128,72 120,78 120,86 Z" fill="#ff7fb2" />
              <path d="M176,66 l3.5,9 9,3.5 -9,3.5 -3.5,9 -3.5,-9 -9,-3.5 9,-3.5 Z" fill="#fff1c9" />
              <path d="M62,76 l2.5,6.5 6.5,2.5 -6.5,2.5 -2.5,6.5 -2.5,-6.5 -6.5,-2.5 6.5,-2.5 Z" fill="#fff1c9" />
              <path d="M120,170 l2,5 5,2 -5,2 -2,5 -2,-5 -5,-2 5,-2 Z" fill="#ffb3d2" />
            </svg>
          </div>

          <h1 class="cover-title">时光魔法书</h1>
          <p class="cover-sub">Time &middot; Album &middot; Magic</p>

          <!-- 四角宝石 -->
          <span class="gem gem-tl"></span>
          <span class="gem gem-tr"></span>
          <span class="gem gem-bl"></span>
          <span class="gem gem-br"></span>

          <!-- 封面星光 -->
          <span
            v-for="(s, i) in sparkles"
            :key="'cv' + i"
            class="cspark"
            :style="{ left: s.left, top: s.top, fontSize: s.size + 'px', animationDuration: s.dur + 's', animationDelay: s.delay + 's' }"
          >✦</span>

          <p class="cover-hint">轻触封面 &middot; 翻开回忆</p>
        </div>
      </div>
    </div>

    <!-- ============ 立绘魔法场景（常驻，动画重放靠 key） ============ -->
    <div class="ta-scene" :class="{ 'scene-show': viewMode === 'scene', leaving: sceneLeaving }">
      <div :key="sceneKey" class="scene-inner">
        <!-- 生成插画背景 -->
<!--        <div class="scene-sky-img" :style="{ backgroundImage: 'url(' + imgs.sky + ')' }"></div>-->
        <div class="scene-sky-tint"></div>
        <div class="scene-glow-orb o1"></div>
        <div class="scene-glow-orb o2"></div>

        <!-- 樱花树（生成插画） -->
        <div class="scene-tree">
          <img :src="imgs.tree" alt="樱花树" draggable="false" />
        </div>

        <!-- 三个立绘角色（生成插画，白底经正片叠底融入背景；从书底浮出） -->
        <div class="char-zone">
          <div class="char lolita" :class="{ focus: sceneFrom === 0 }">
            <div class="char-rise" :style="charSinkStyle">
              <div class="char-inner"><img :src="imgs.lolita" alt="洛丽塔" draggable="false" /></div>
            </div>
          </div>
          <div class="char jk" :class="{ focus: sceneFrom === 1 }">
            <div class="char-rise" :style="charSinkStyle">
              <div class="char-inner"><img :src="imgs.jk" alt="JK" draggable="false" /></div>
            </div>
          </div>
          <div class="char hanfu" :class="{ focus: sceneFrom === 0 }">
            <div class="char-rise" :style="charSinkStyle">
              <div class="char-inner"><img :src="imgs.hanfu" alt="汉服" draggable="false" /></div>
            </div>
          </div>
        </div>

        <!-- 地面底座：从书底自下而上浮出 -->
<!--        <div class="scene-ground">-->
<!--          <span class="ground-title">时光之书 &middot; 第 {{ sceneFrom === 0 ? '四' : '七' }} 页</span>-->
<!--        </div>-->

        <!-- 飘落花瓣（生成花瓣插画） -->
        <div class="scene-petals">
          <img
            v-for="(p, i) in petals"
            :key="'pt' + i"
            class="petal"
            :src="imgs.petal"
            :style="{ left: p.left, width: p.size + 'px', height: (p.size * 0.8) + 'px', animationDuration: p.dur + 's', animationDelay: p.delay + 's' }"
            draggable="false"
          />
        </div>

        <!-- 场景星光 -->
        <span
          v-for="(s, i) in sceneSparks"
          :key="'ss' + i"
          class="sspark"
          :style="{ left: s.left, top: s.top, fontSize: s.size + 'px', animationDuration: s.dur + 's', animationDelay: s.delay + 's' }"
        >✦</span>

        <button class="scene-back" @click="exitScene">
          <span class="sb-ic">📖</span> 返回相册
        </button>
        </div>
      </div>

    <!-- ============ 魔法书主体 ============ -->
    <div class="ta-bookwrap" :class="{ toppling: toppling }" :style="bookStyle">
      <div class="ta-book" :class="{ open: isOpen }">
        <!-- 书底 -->
        <div class="book-base"></div>

        <!-- 内容页（8 片书叶） -->
        <div
          v-for="(p, i) in pages"
          :key="p.id"
          class="ta-leaf"
          :class="leafCls(i)"
          :style="{ zIndex: leafZ(i) }"
        >
          <div class="face front">
            <div class="page" :class="'pg-' + p.id">
              <!-- 手账故事页 -->
              <template v-if="p.type === 'story'">
                <span class="tape tp-a" :style="{ background: p.tapeA }"></span>
                <span class="tape tp-b" :style="{ background: p.tapeB }"></span>

                <div class="page-head">
                  <span class="chapter-badge" :style="{ background: p.badgeBg }">{{ p.chapter }}</span>
                  <h2 class="page-title" :style="{ color: p.accent }">{{ p.title }}</h2>
                </div>

                <div class="page-body">
                  <!-- 相片（文字环绕） -->
                  <figure
                    v-for="(ph, j) in p.photos"
                    :key="j"
                    class="photo"
                    :class="[ph.kind, ph.side, { pop: photoPop === p.id + '-' + j }]"
                    :style="{ '--rot': ph.rot + 'deg', width: ph.w }"
                    @click="photoPop = p.id + '-' + j"
                    @animationend="photoPop = ''"
                  >
                    <span class="art" v-html="arts[ph.art]"></span>
                    <figcaption class="cap">{{ ph.cap }}</figcaption>
                  </figure>

                  <div
                    v-for="(d, k) in p.doodles"
                    :key="'d' + k"
                    class="doodle"
                    :style="{ left: d.left, top: d.top, transform: 'rotate(' + d.rot + 'deg)', width: d.size + 'px' }"
                    v-html="doodles[d.k]"
                  ></div>

                  <div class="page-text">
                    <p v-for="(t, m) in p.paras" :key="m">{{ t }}</p>
                  </div>
                </div>

                <div class="page-foot">
                  <span class="foot-quote" :style="{ color: p.accent }">“{{ p.quote }}”</span>
                  <span class="page-num" :style="{ color: p.accent }">{{ p.page }}</span>
                </div>
              </template>

              <!-- 立绘页 -->
              <template v-else>
                <span class="tape tp-a" :style="{ background: p.tapeA }"></span>
                <span class="tape tp-b" :style="{ background: p.tapeB }"></span>

                <div class="page-head">
                  <span class="chapter-badge art-badge" :style="{ background: p.badgeBg }">{{ p.chapter }}</span>
                  <h2 class="page-title" :style="{ color: p.accent }">{{ p.title }}</h2>
                </div>

                <div class="art-page">
                  <!-- 洛丽塔立绘页（sceneFrom 0）：单张插画卡 -->
                  <template v-if="p.sceneFrom === 0">
                    <div class="art-card art-card-lolita">
                      <img :src="imgs.lolita" alt="洛丽塔" draggable="false" />
                      <span class="ac-label">洛丽塔 · Lolita</span>
                    </div>
                  </template>
                  <!-- JK & 汉服立绘页（sceneFrom 1）：双插画卡 -->
                  <template v-else>
                    <div class="art-cards">
                      <div class="art-card">
                        <img :src="imgs.jk" alt="JK" draggable="false" />
                        <span class="ac-label">JK · 水手服</span>
                      </div>
                      <div class="art-card">
                        <img :src="imgs.hanfu" alt="汉服" draggable="false" />
                        <span class="ac-label">汉服 · 齐胸襦裙</span>
                      </div>
                    </div>
                  </template>
                  <div class="art-info">
                    <h3 class="art-name">{{ p.artName }}</h3>
                    <p class="art-desc">{{ p.desc }}</p>
                    <ul class="art-tags">
                      <li v-for="(t, ti) in p.tags" :key="ti">{{ t }}</li>
                    </ul>
                    <button class="art-btn" @click="enterScene(p.sceneFrom)">
                      <span class="ab-spark">✦</span> 查看立绘 <span class="ab-spark">✦</span>
                    </button>
                  </div>
                </div>

                <div class="art-foot">轻触按钮 &middot; 让她们从书中苏醒</div>
              </template>
            </div>
            <div class="flip-shade"></div>
          </div>

          <div class="face back">
            <div class="reverse">
              <div class="rev-flower" v-html="flower"></div>
              <div class="rev-title" :style="{ color: p.accent }">{{ p.chapter }} · {{ p.title }}</div>
              <div class="rev-quote">“{{ p.quote }}”</div>
              <div class="rev-num" :style="{ color: p.accent }">P.{{ p.page }}</div>
              <div class="rev-note">✦ 风把这一页吹到了这里</div>
            </div>
          </div>
        </div>

        <!-- 封面书叶（背面 = 目录） -->
        <div class="ta-leaf ta-cover" :class="{ flipped: isOpen }" :style="{ zIndex: coverZ }">
          <div class="face front">
            <div class="cover-inner-face">
              <svg class="ci-ornament" viewBox="0 0 200 200" aria-hidden="true">
                <g fill="none" stroke="rgba(255,205,150,.7)" stroke-width="2">
                  <path d="M10,200 V60 Q10,10 60,10 H200" />
                  <circle cx="10" cy="200" r="6" fill="rgba(255,205,150,.85)" stroke="none" />
                </g>
              </svg>
            </div>
          </div>
          <div class="face back">
            <div class="toc">
              <div class="toc-head">
                <span class="toc-kicker">✦ 魔法书 ✦</span>
                <h2 class="toc-title">目 录</h2>
                <span class="toc-line"></span>
              </div>
              <ul class="toc-list">
                <li v-for="(it, i) in tocItems" :key="i" @click="jumpTo(i)">
                  <span class="toc-num" :style="{ color: it.color }">{{ it.num }}</span>
                  <span class="toc-icon" v-html="icons[it.icon]"></span>
                  <span class="toc-name">{{ it.name }}</span>
                  <span class="toc-dots"></span>
                  <span class="toc-page">P.{{ it.page }}</span>
                </li>
              </ul>
              <p class="toc-hint">轻触条目 &middot; 前往记忆之页</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 翻页导航 -->
    <button
      v-if="isOpen && viewMode === 'book'"
      class="nav-btn nav-prev"
      title="上一页 / 合上书本"
      @click="goPrev"
    >‹</button>
    <button
      v-if="isOpen && viewMode === 'book'"
      class="nav-btn nav-next"
      title="下一页 / 合上书本"
      @click="goNext"
    >›</button>
    <button
      v-if="isOpen && viewMode === 'book' && currentIndex > 0"
      class="nav-btn nav-toc"
      title="回到目录"
      @click="goToc"
    >✦ 目录</button>
    <button
      v-if="isOpen && viewMode === 'book'"
      class="nav-btn nav-close"
      title="合上书本"
      @click="closeBook"
    >合上</button>

    <!-- 跳转闪光 -->
    <div class="ta-flash" :class="{ on: jumpFlash }"></div>

    <!-- 翻开时的星光迸发 -->
    <div v-if="burst" class="fx-burst">
      <span
        v-for="(b, i) in burstSparks"
        :key="'b' + i"
        :style="{ '--ang': b.ang + 'deg', '--dist': b.dist + 'px', animationDelay: b.delay + 's' }"
      >✦</span>
    </div>
    </div>
  </div>
</template>

<script>
/* ================= 生成插画素材（放置于同目录 assets/ 下） ================= */
import lolitaImg from './assets/lolita.jpg';
import jkImg from './assets/jk.jpg';
import hanfuImg from './assets/hanfu.jpg';
import treeImg from './assets/tree.jpg';
import skyImg from './assets/sky.jpg';
import petalImg from './assets/petal.jpg';

/* ================= 内联 SVG 素材 ================= */
const ART = {
  sakura: `<svg viewBox="0 0 260 300" xmlns="http://www.w3.org/2000/svg">
  <defs><linearGradient id="a-sk" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#ffe9f4"/><stop offset="1" stop-color="#fff6ef"/></linearGradient></defs>
  <rect width="260" height="300" fill="url(#a-sk)"/>
  <path d="M0,300 Q0,58 130,18 Q260,58 260,300 Z" fill="#ffe3f1" opacity="0.65"/>
  <g fill="#ffc4de">
    <circle cx="20" cy="42" r="26"/><circle cx="60" cy="18" r="30"/><circle cx="110" cy="10" r="32"/><circle cx="160" cy="12" r="30"/><circle cx="215" cy="26" r="30"/><circle cx="248" cy="62" r="24"/>
  </g>
  <g fill="#ff9dcb">
    <circle cx="45" cy="28" r="18"/><circle cx="90" cy="8" r="20"/><circle cx="135" cy="6" r="18"/><circle cx="185" cy="18" r="20"/><circle cx="228" cy="44" r="16"/>
  </g>
  <g fill="#ff7cb4">
    <circle cx="70" cy="16" r="10"/><circle cx="120" cy="14" r="10"/><circle cx="175" cy="12" r="10"/><circle cx="30" cy="66" r="8"/>
  </g>
  <path d="M0,300 L0,242 Q130,212 260,242 L260,300 Z" fill="#ffe3d8"/>
  <ellipse cx="130" cy="250" rx="150" ry="16" fill="#ffffff" opacity="0.5"/>
  <g fill="#ffb3d2">
    <circle cx="70" cy="118" r="3.2"/><circle cx="150" cy="150" r="2.6"/><circle cx="200" cy="100" r="3"/><circle cx="110" cy="198" r="2.2"/><circle cx="232" cy="168" r="2.6"/><circle cx="40" cy="180" r="2.4"/>
  </g>
</svg>`,

  picnic: `<svg viewBox="0 0 260 300" xmlns="http://www.w3.org/2000/svg">
  <defs><linearGradient id="a-pc" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#dff0ff"/><stop offset="1" stop-color="#fff3e8"/></linearGradient></defs>
  <rect width="260" height="300" fill="url(#a-pc)"/>
  <circle cx="220" cy="48" r="30" fill="#ffe9a8" opacity="0.9"/>
  <path d="M130,300 L130,220 Q150,210 150,220 L150,300 Z" fill="#a96a52"/>
  <ellipse cx="150" cy="196" rx="58" ry="40" fill="#ffc4de"/>
  <ellipse cx="120" cy="186" rx="34" ry="24" fill="#ffd7ec"/>
  <ellipse cx="176" cy="188" rx="32" ry="22" fill="#ffd7ec"/>
  <g fill="#ff7cb4"><circle cx="140" cy="180" r="6"/><circle cx="166" cy="182" r="5"/><circle cx="152" cy="196" r="5"/></g>
  <path d="M10,268 Q130,240 250,268 L250,300 L10,300 Z" fill="#ff9ccb"/>
  <path d="M10,268 Q130,240 250,268" fill="none" stroke="#fff" stroke-width="2" opacity="0.6"/>
  <rect x="52" y="242" width="44" height="16" rx="4" fill="#fff" opacity="0.9"/>
  <rect x="56" y="246" width="36" height="8" rx="3" fill="#f6c9a0"/>
  <rect x="168" y="246" width="40" height="14" rx="4" fill="#fff" opacity="0.9"/>
  <circle cx="178" cy="252" r="6" fill="#ff7fb2"/><circle cx="192" cy="252" r="6" fill="#ffd98a"/>
  <g fill="#ffb3d2"><circle cx="40" cy="120" r="3"/><circle cx="120" cy="90" r="2.4"/><circle cx="210" cy="150" r="2.8"/><circle cx="80" cy="170" r="2.2"/></g>
</svg>`,

  tea: `<svg viewBox="0 0 260 300" xmlns="http://www.w3.org/2000/svg">
  <defs><linearGradient id="a-te" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#fff2e6"/><stop offset="1" stop-color="#ffe4ee"/></linearGradient></defs>
  <rect width="260" height="300" fill="url(#a-te)"/>
  <path d="M30,240 Q130,220 230,240 L230,300 L30,300 Z" fill="#c98a6a"/>
  <path d="M30,240 Q130,220 230,240" fill="none" stroke="#fff" stroke-width="2.5" opacity="0.7"/>
  <g fill="#fff">
    <circle cx="70" cy="196" r="18"/><circle cx="118" cy="186" r="22"/><circle cx="160" cy="196" r="17"/><circle cx="204" cy="190" r="18"/>
  </g>
  <circle cx="118" cy="186" r="22" fill="none" stroke="#f3a9c6" stroke-width="2"/>
  <path d="M96,186 l6,-8 5,6 6,-10 6,10 5,-6 6,8" fill="none" stroke="#f3a9c6" stroke-width="2.2"/>
  <circle cx="118" cy="186" r="4" fill="#ff7fb2"/>
  <path d="M150,214 q20,-4 30,-18 q8,-12 0,-22 q14,4 14,20 q0,20 -22,28 q-14,6 -22,-8 Z" fill="#fff7fb"/>
  <path d="M178,196 q6,-4 8,-10" fill="none" stroke="#f7c9a0" stroke-width="3" stroke-linecap="round"/>
  <path d="M150,214 q20,-4 30,-18" fill="none" stroke="#e8b3c8" stroke-width="2"/>
  <path d="M70,250 l0,-22 M118,250 l0,-30 M160,250 l0,-20 M204,250 l0,-24" stroke="#fff" stroke-width="2" opacity="0.8"/>
  <g fill="#ffb3d2"><circle cx="46" cy="100" r="3"/><circle cx="150" cy="80" r="2.6"/><circle cx="220" cy="110" r="2.4"/></g>
  <path d="M104,150 q6,-14 12,0 M134,142 q6,-12 12,0" stroke="#e8b3c8" stroke-width="3" fill="none" stroke-linecap="round" opacity="0.7"/>
</svg>`,

  summer: `<svg viewBox="0 0 260 300" xmlns="http://www.w3.org/2000/svg">
  <defs><linearGradient id="a-su" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#ffe9f6"/><stop offset="0.6" stop-color="#fff2e2"/><stop offset="1" stop-color="#ffe6ec"/></linearGradient></defs>
  <rect width="260" height="300" fill="url(#a-su)"/>
  <circle cx="196" cy="70" r="34" fill="#ffe9a8"/>
  <g fill="#fff" opacity="0.92">
    <ellipse cx="60" cy="66" rx="34" ry="13"/><ellipse cx="96" cy="58" rx="26" ry="10"/><ellipse cx="150" cy="72" rx="30" ry="12"/><ellipse cx="120" cy="96" rx="22" ry="9"/>
  </g>
  <path d="M0,220 Q65,196 130,220 Q195,244 260,220 L260,300 L0,300 Z" fill="#9fd3f0"/>
  <path d="M0,238 Q65,216 130,238 Q195,260 260,238" fill="none" stroke="#fff" stroke-width="3" opacity="0.85"/>
  <path d="M0,258 Q65,238 130,258 Q195,278 260,258" fill="none" stroke="#fff" stroke-width="2" opacity="0.55"/>
  <path d="M120,120 L132,102 L144,120 L132,138 Z" fill="#fff" opacity="0.9"/>
  <path d="M132,138 L120,120 L132,102 L144,120 Z" fill="none" stroke="#f3a9c6" stroke-width="1.5"/>
  <g fill="#ffb3d2"><circle cx="70" cy="150" r="2.6"/><circle cx="200" cy="160" r="2.4"/><circle cx="150" cy="180" r="2.2"/></g>
</svg>`,

  hanfu: `<svg viewBox="0 0 260 300" xmlns="http://www.w3.org/2000/svg">
  <defs>
    <linearGradient id="a-hf" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#fff0f6"/><stop offset="1" stop-color="#ffe4f0"/></linearGradient>
    <linearGradient id="a-hs" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#ffd7ea"/><stop offset="1" stop-color="#ff9ccb"/></linearGradient>
  </defs>
  <rect width="260" height="300" fill="url(#a-hf)"/>
  <path d="M30,250 Q70,210 60,140 Q90,120 120,150 Q140,110 170,140 Q200,120 210,180 Q220,230 250,250 L250,300 L30,300 Z" fill="url(#a-hs)" opacity="0.85"/>
  <path d="M30,250 Q70,210 60,140 Q90,120 120,150 Q140,110 170,140 Q200,120 210,180 Q220,230 250,250" fill="none" stroke="#fff" stroke-width="2" opacity="0.6"/>
  <g fill="#ff7fb2">
    <circle cx="70" cy="170" r="14"/><circle cx="92" cy="160" r="12"/><circle cx="78" cy="190" r="11"/><circle cx="96" cy="184" r="10"/>
  </g>
  <g fill="#ffd98a"><circle cx="70" cy="170" r="6"/><circle cx="92" cy="160" r="5"/></g>
  <circle cx="196" cy="120" r="26" fill="#ffc4de"/>
  <circle cx="196" cy="120" r="26" fill="none" stroke="#ff8ec0" stroke-width="2"/>
  <path d="M196,104 l5,10 10,5 -10,5 -5,10 -5,-10 -10,-5 10,-5 Z" fill="#fff"/>
  <path d="M196,128 q-5,-2 -5,-8 q5,2 5,8 Z" fill="#fff"/>
  <path d="M194,146 l4,20" stroke="#d9a25a" stroke-width="3" stroke-linecap="round"/>
  <path d="M196,104 l5,10 10,5 -10,5 -5,10 -5,-10 -10,-5 10,-5 Z" fill="#ff8ec0" opacity="0.35"/>
  <g fill="#ffb3d2"><circle cx="46" cy="90" r="3"/><circle cx="140" cy="70" r="2.6"/><circle cx="220" cy="80" r="2.4"/></g>
</svg>`,

  sunset: `<svg viewBox="0 0 260 300" xmlns="http://www.w3.org/2000/svg">
  <defs><linearGradient id="a-st" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#ffd3e6"/><stop offset="0.55" stop-color="#ffc9d8"/><stop offset="1" stop-color="#ffe9b0"/></linearGradient></defs>
  <rect width="260" height="300" fill="url(#a-st)"/>
  <circle cx="130" cy="196" r="44" fill="#ffdf9e"/>
  <path d="M0,236 Q65,220 130,236 Q195,252 260,236 L260,300 L0,300 Z" fill="#c99bb8"/>
  <path d="M0,252 Q65,238 130,252 Q195,266 260,252" fill="none" stroke="#ffdf9e" stroke-width="2" opacity="0.6"/>
  <g fill="none" stroke="#8a5a72" stroke-width="2.4" stroke-linecap="round">
    <path d="M70,80 q10,-8 20,0 q10,8 20,0"/>
    <path d="M150,56 q10,-8 20,0 q10,8 20,0"/>
    <path d="M116,104 q8,-6 16,0 q8,6 16,0"/>
  </g>
  <g fill="#7c4a68">
    <path d="M60,236 L70,212 L80,236 Z"/>
    <path d="M96,236 L106,216 L116,236 Z"/>
    <path d="M140,236 L148,218 L156,236 Z"/>
  </g>
</svg>`,

  group: `<svg viewBox="0 0 260 300" xmlns="http://www.w3.org/2000/svg">
  <defs><linearGradient id="a-gr" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#ffe7f2"/><stop offset="1" stop-color="#fff4e9"/></linearGradient></defs>
  <rect width="260" height="300" fill="url(#a-gr)"/>
  <circle cx="196" cy="60" r="30" fill="#ffe9a8" opacity="0.85"/>
  <ellipse cx="170" cy="210" rx="70" ry="34" fill="#ffc4de"/>
  <ellipse cx="140" cy="202" rx="40" ry="22" fill="#ffd7ec"/>
  <g fill="#ff7cb4"><circle cx="150" cy="196" r="6"/><circle cx="180" cy="200" r="5"/><circle cx="164" cy="212" r="5"/></g>
  <g>
    <path d="M96,252 l0,-40 q0,-12 12,-12 q12,0 12,12 l0,40 Z" fill="#ff9ccb"/>
    <circle cx="108" cy="196" r="13" fill="#ffe9dd"/>
    <path d="M96,196 q0,-14 12,-14 q12,0 12,14 Z" fill="#f2a7c3"/>
  </g>
  <g>
    <path d="M126,252 l0,-40 q0,-12 12,-12 q12,0 12,12 l0,40 Z" fill="#ffd98a"/>
    <circle cx="138" cy="196" r="13" fill="#ffe9dd"/>
    <path d="M126,196 q0,-14 12,-14 q12,0 12,14 Z" fill="#e9a3b8"/>
  </g>
  <g>
    <path d="M156,252 l0,-40 q0,-12 12,-12 q12,0 12,12 l0,40 Z" fill="#ff7fb2"/>
    <circle cx="168" cy="196" r="13" fill="#ffe9dd"/>
    <path d="M156,196 q0,-14 12,-14 q12,0 12,14 Z" fill="#5b3a52"/>
  </g>
  <path d="M10,262 Q130,244 250,262 L250,300 L10,300 Z" fill="#ffe0d2"/>
  <g fill="#ffb3d2"><circle cx="60" cy="110" r="3"/><circle cx="140" cy="90" r="2.6"/><circle cx="220" cy="130" r="2.4"/></g>
</svg>`
};

const DOODLES = {
  star: `<svg viewBox="0 0 32 32"><path d="M16,4 l3.4,8.6 8.6,3.4 -8.6,3.4 -3.4,8.6 -3.4,-8.6 -8.6,-3.4 8.6,-3.4 Z" fill="#ffd98a" opacity="0.9"/></svg>`,
  heart: `<svg viewBox="0 0 32 32"><path d="M16,28 C8,22 4,16 6,10.5 C7.6,6.5 13,5 16,9 C19,5 24.4,6.5 26,10.5 C28,16 24,22 16,28 Z" fill="#ff8fae" opacity="0.85"/></svg>`,
  spark: `<svg viewBox="0 0 32 32"><path d="M16,6 l3,7 7,3 -7,3 -3,7 -3,-7 -7,-3 7,-3 Z" fill="#ffc9de"/><circle cx="16" cy="16" r="3.4" fill="#ff8ec0"/></svg>`,
  butterfly: `<svg viewBox="0 0 40 40"><path d="M20,20 C14,12 4,10 6,18 C7.6,23.4 14,23 20,20 Z M20,20 C26,12 36,10 34,18 C32.4,23.4 26,23 20,20 Z" fill="#ffb3d2"/><path d="M20,20 C15,24 13,30 16,32 C18,33 20,29 20,20 Z M20,20 C25,24 27,30 24,32 C22,33 20,29 20,20 Z" fill="#ff8ec0"/><circle cx="20" cy="19" r="2.2" fill="#e98fb4"/></svg>`,
  candy: `<svg viewBox="0 0 40 40"><rect x="8" y="14" width="24" height="12" rx="6" fill="#ffb3d2" transform="rotate(-30 20 20)"/><rect x="8" y="14" width="24" height="12" rx="6" fill="#fff" opacity="0.4" transform="rotate(-30 20 20)"/><circle cx="14" cy="26" r="4" fill="#ff8ec0"/><circle cx="26" cy="14" r="4" fill="#ffd98a"/></svg>`,
  cloud: `<svg viewBox="0 0 48 32"><ellipse cx="16" cy="18" rx="12" ry="8" fill="#fff" opacity="0.85"/><ellipse cx="28" cy="14" rx="14" ry="9" fill="#fff" opacity="0.9"/><ellipse cx="38" cy="20" rx="9" ry="6" fill="#fff" opacity="0.75"/></svg>`
};

const FLOWER = `<svg viewBox="0 0 96 96" xmlns="http://www.w3.org/2000/svg">
  <g fill="#ffc4de">
    <ellipse cx="48" cy="22" rx="9" ry="16"/><ellipse cx="48" cy="22" rx="9" ry="16" transform="rotate(72 48 48)"/><ellipse cx="48" cy="22" rx="9" ry="16" transform="rotate(144 48 48)"/><ellipse cx="48" cy="22" rx="9" ry="16" transform="rotate(216 48 48)"/><ellipse cx="48" cy="22" rx="9" ry="16" transform="rotate(288 48 48)"/>
  </g>
  <circle cx="48" cy="48" r="7" fill="#ffd98a"/>
  <circle cx="48" cy="48" r="3.2" fill="#ff8ec0"/>
</svg>`;

const ICONS = {
  sakura: `<svg viewBox="0 0 24 24"><g fill="#ff9ccb"><circle cx="12" cy="12" r="4"/><circle cx="18" cy="9" r="3"/><circle cx="8" cy="7" r="2.6"/><circle cx="19" cy="16" r="2.6"/><circle cx="7" cy="17" r="2.2"/></g><circle cx="12" cy="12" r="1.8" fill="#ffd98a"/></svg>`,
  cake: `<svg viewBox="0 0 24 24"><path d="M5,14 h14 l-2,6 h-10 Z" fill="#ffc4de"/><path d="M7,14 q2,-2 4,0 q2,2 4,0 q2,-2 4,0" fill="#fff" stroke="#ff9ccb" stroke-width="1"/><circle cx="12" cy="11" r="3" fill="#ff7fb2"/><rect x="10.6" y="6" width="2.8" height="3" rx="1.4" fill="#ffd98a"/></svg>`,
  dress: `<svg viewBox="0 0 24 24"><path d="M9,6 h6 l1.4,3 -3.4,2 -3.4,-2 Z" fill="#ff9ccb"/><path d="M12,11 l-4,9 h8 Z" fill="#ffbcd9"/><path d="M8,15 a4,4 0 0 0 8,0" fill="none" stroke="#fff" stroke-width="1.2"/><circle cx="12" cy="6" r="1.6" fill="#ffd98a"/></svg>`,
  sun: `<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="5" fill="#ffd98a"/><g stroke="#ffc98a" stroke-width="1.8" stroke-linecap="round"><path d="M12,3 v2.4 M12,18.6 v2.4 M3,12 h2.4 M18.6,12 h2.4 M5.8,5.8 l1.7,1.7 M16.5,16.5 l1.7,1.7 M18.2,5.8 l-1.7,1.7 M7.5,16.5 l-1.7,1.7"/></g></svg>`,
  fan: `<svg viewBox="0 0 24 24"><path d="M12,10 a6.4,6.4 0 0 1 6.4,6.4 a6.4,6.4 0 0 1 -12.8,0 a6.4,6.4 0 0 1 6.4,-6.4 Z" fill="#ffc4de" stroke="#ff8ec0" stroke-width="1"/><path d="M12,10 l4,7" stroke="#ff8ec0" stroke-width="1"/><path d="M12,10 l-4,7" stroke="#ff8ec0" stroke-width="1"/><path d="M12,10 l0,8" stroke="#ff8ec0" stroke-width="1"/><path d="M12,17.6 l-2,3.4 h4 Z" fill="#d9a25a"/></svg>`,
  star: `<svg viewBox="0 0 24 24"><path d="M12,4 l2.4,5.6 5.6,2.4 -5.6,2.4 -2.4,5.6 -2.4,-5.6 -5.6,-2.4 5.6,-2.4 Z" fill="#ffd98a"/></svg>`,
  heart: `<svg viewBox="0 0 24 24"><path d="M12,21 C6,16 3,11.5 4.6,7.3 C5.9,4 10,3.6 12,6.6 C14,3.6 18.1,4 19.4,7.3 C21,11.5 18,16 12,21 Z" fill="#ff8fae"/></svg>`
};

/* ================= 三位角色立绘（粉色系） ================= */
import HeaderNav from '../HeaderNav.vue';

export default {
  name: 'TimeAlbum',
  components: { HeaderNav },
  data() {
    return {
      isOpen: false,
      coverMoving: false,
      flipping: false,
      flipTarget: -2,
      flipFast: false,
      jumpFlash: false,
      currentIndex: 0,
      viewMode: 'book',
      sceneLeaving: false,
      toppling: false,
      bookDeg: 0,
      charSink: 0,
      sceneKey: 0,
      rising: false,
      sceneFrom: 0,
      photoPop: '',
      burst: false,
      sparkles: [],
      sceneSparks: [],
      petals: [],
      arts: ART,
      doodles: DOODLES,
      imgs: {
        lolita: lolitaImg,
        jk: jkImg,
        hanfu: hanfuImg,
        tree: treeImg,
        sky: skyImg,
        petal: petalImg
      },
      icons: ICONS,
      flower: FLOWER,
      tocItems: [
        { num: '01', icon: 'sakura', name: '序 · 初见樱时', page: 1, color: '#e77fb0' },
        { num: '02', icon: 'sakura', name: '樱 · 春日物语', page: 2, color: '#ef8fb8' },
        { num: '03', icon: 'cake', name: '甜 · 午后茶会', page: 3, color: '#f2a3a0' },
        { num: '04', icon: 'dress', name: '裙 · 洛丽塔之梦 ✦', page: 4, color: '#e9689e' },
        { num: '05', icon: 'sun', name: '夏 · 青春回响', page: 5, color: '#f0a868' },
        { num: '06', icon: 'fan', name: '华 · 霓裳流韵', page: 6, color: '#d98ab8' },
        { num: '07', icon: 'star', name: '梦 · 纸上的她们 ✦', page: 7, color: '#c98ae0' },
        { num: '08', icon: 'heart', name: '终 · 未完待续', page: 8, color: '#ff7f9e' }
      ],
      pages: [
        {
          id: 'p1', page: 1, type: 'story', chapter: '序', title: '初见樱时', accent: '#e77fb0',
          quote: '所有的相遇，都是久别重逢',
          badgeBg: 'radial-gradient(circle at 35% 30%, #ffd7ea, #ff9ccb)',
          tapeA: 'repeating-linear-gradient(45deg, rgba(255,255,255,.7) 0 5px, rgba(255,178,208,.55) 5px 11px)',
          tapeB: 'repeating-linear-gradient(-45deg, rgba(255,255,255,.7) 0 5px, rgba(255,215,150,.6) 5px 11px)',
          photos: [
            { art: 'sakura', cap: '那年春天 · 樱花隧道', side: 'left', kind: 'polaroid', rot: -3, w: '44%' }
          ],
          paras: [
            '翻开这本魔法书，风便从书页间溜过，卷起那年春天的一缕花香。',
            '有人说，时光是一本没有页数的书，而我偏偏把最舍不得的几页，折成了这里的风景。',
            '第一页，是初见。那天下着小雨，樱花却开得正好，你在隧道尽头回眸一笑。'
          ],
          doodles: [
            { k: 'star', left: '70%', top: '20%', rot: 12, size: 26 },
            { k: 'butterfly', left: '76%', top: '52%', rot: -8, size: 30 },
            { k: 'spark', left: '8%', top: '60%', rot: 20, size: 22 }
          ]
        },
        {
          id: 'p2', page: 2, type: 'story', chapter: '樱', title: '春日物语', accent: '#ef8fb8',
          quote: '花吹雪之下，与你们共赴一场野餐',
          badgeBg: 'radial-gradient(circle at 35% 30%, #ffd7ea, #ff8ec0)',
          tapeA: 'repeating-linear-gradient(45deg, rgba(255,255,255,.7) 0 5px, rgba(180,210,255,.55) 5px 11px)',
          tapeB: 'repeating-linear-gradient(-45deg, rgba(255,255,255,.7) 0 5px, rgba(255,178,208,.55) 5px 11px)',
          photos: [
            { art: 'picnic', cap: '樱花树下的便当', side: 'right', kind: 'polaroid', rot: 2.5, w: '46%' }
          ],
          paras: [
            '风一吹，满树的花瓣就落进便当盒里，谁也没有把它挑出来。',
            '我们坐在粉色的毯子上，分享三明治和橘子汽水，笑声把头顶的云都惊散了。',
            '花瓣沾在发梢上，像春天偷偷给我们别上的发卡。那天谁也没有说再见，只约好了明年还来。'
          ],
          doodles: [
            { k: 'candy', left: '8%', top: '18%', rot: -14, size: 30 },
            { k: 'heart', left: '72%', top: '30%', rot: 10, size: 24 },
            { k: 'cloud', left: '10%', top: '66%', rot: 0, size: 44 }
          ]
        },
        {
          id: 'p3', page: 3, type: 'story', chapter: '甜', title: '午后茶会', accent: '#f09aa8',
          quote: '甜度刚好，像极了和你度过的下午',
          badgeBg: 'radial-gradient(circle at 35% 30%, #ffe3c9, #f7a8a0)',
          tapeA: 'repeating-linear-gradient(45deg, rgba(255,255,255,.7) 0 5px, rgba(255,215,150,.6) 5px 11px)',
          tapeB: 'repeating-linear-gradient(-45deg, rgba(255,255,255,.7) 0 5px, rgba(190,215,255,.6) 5px 11px)',
          photos: [
            { art: 'tea', cap: '', side: 'left', kind: 'circle', rot: 0, w: '46%' }
          ],
          paras: [
            '奶油在草莓蛋糕上慢慢融化，红茶的热气把窗玻璃染成毛茸茸的白。',
            '我们聊到笑出眼泪，又安静下来听雨。杯底剩下的一小块糖，谁也没有舍得吃掉。',
            '甜的东西总是让人记很久——像那年下午的蛋糕，像你们。'
          ],
          doodles: [
            { k: 'heart', left: '66%', top: '16%', rot: -12, size: 26 },
            { k: 'star', left: '70%', top: '58%', rot: 14, size: 22 },
            { k: 'spark', left: '84%', top: '34%', rot: 0, size: 20 }
          ]
        },
        {
          id: 'p4', page: 4, type: 'art', chapter: '裙', title: '洛丽塔之梦', accent: '#e9689e', sceneFrom: 0,
          artName: '洛丽塔 · Lolita',
          desc: '层层叠叠的蕾丝与缎带，是藏在衣柜深处的少女梦。蝴蝶结轻轻一系，便拴住了整个下午的甜。',
          tags: ['双马尾', '蕾丝茶会裙', '缎带蝴蝶结', '魔法棒'],
          badgeBg: 'radial-gradient(circle at 35% 30%, #ffd7ea, #ff7fb4)',
          tapeA: 'repeating-linear-gradient(45deg, rgba(255,255,255,.7) 0 5px, rgba(255,178,208,.6) 5px 11px)',
          tapeB: 'repeating-linear-gradient(-45deg, rgba(255,255,255,.7) 0 5px, rgba(255,217,138,.6) 5px 11px)',
          quote: '裙摆摇一摇，梦就开了花',
          doodles: []
        },
        {
          id: 'p5', page: 5, type: 'story', chapter: '夏', title: '青春回响', accent: '#f0a868',
          quote: '夏天的风，吹起了校服裙摆',
          badgeBg: 'radial-gradient(circle at 35% 30%, #ffe9c9, #ffb980)',
          tapeA: 'repeating-linear-gradient(45deg, rgba(255,255,255,.7) 0 5px, rgba(190,215,255,.6) 5px 11px)',
          tapeB: 'repeating-linear-gradient(-45deg, rgba(255,255,255,.7) 0 5px, rgba(255,178,208,.55) 5px 11px)',
          photos: [
            { art: 'summer', cap: '放学后的天空', side: 'right', kind: 'polaroid', rot: -2, w: '46%' }
          ],
          paras: [
            '蝉鸣把下午拉得很长，粉色的水手服在风里鼓成一朵小小的帆。',
            '我们趴在走廊栏杆上，数着云，猜今年的烟火大会会不会下雨。',
            '青春大概就是这样的吧——裙摆、汽水、写了一半的情书，和永远不够用的夏天。'
          ],
          doodles: [
            { k: 'butterfly', left: '8%', top: '20%', rot: 10, size: 30 },
            { k: 'star', left: '74%', top: '62%', rot: -8, size: 24 }
          ]
        },
        {
          id: 'p6', page: 6, type: 'story', chapter: '华', title: '霓裳流韵', accent: '#d98ab8',
          quote: '广袖流云，一步生花',
          badgeBg: 'radial-gradient(circle at 35% 30%, #ffd7ea, #d98ab8)',
          tapeA: 'repeating-linear-gradient(45deg, rgba(255,255,255,.7) 0 5px, rgba(255,217,138,.6) 5px 11px)',
          tapeB: 'repeating-linear-gradient(-45deg, rgba(255,255,255,.7) 0 5px, rgba(190,215,255,.6) 5px 11px)',
          photos: [
            { art: 'hanfu', cap: '衣袂翻飞 · 团扇轻摇', side: 'left', kind: 'polaroid', rot: 3, w: '44%' }
          ],
          paras: [
            '广袖一扬，流云便落进了衣袖；团扇半掩，羞色便漫上了眉梢。',
            '发间的海棠花垂到耳边，走一步，裙裾就荡开一朵涟漪。',
            '原来汉服穿上的那一刻，风都会温柔三分，古意也悄悄活了过来。'
          ],
          doodles: [
            { k: 'spark', left: '70%', top: '18%', rot: 15, size: 24 },
            { k: 'heart', left: '76%', top: '54%', rot: -10, size: 26 }
          ]
        },
        {
          id: 'p7', page: 7, type: 'art', chapter: '梦', title: '纸上的她们', accent: '#c98ae0', sceneFrom: 1,
          artName: 'JK & 汉服',
          desc: '一个把青春穿在身上，一个把诗卷别在发间。她们在纸页间悄悄醒来，乘着花瓣轻轻浮动。',
          tags: ['水手服', '百褶裙', '广袖罗裙', '团扇'],
          badgeBg: 'radial-gradient(circle at 35% 30%, #efd9ff, #c98ae0)',
          tapeA: 'repeating-linear-gradient(45deg, rgba(255,255,255,.7) 0 5px, rgba(210,180,255,.6) 5px 11px)',
          tapeB: 'repeating-linear-gradient(-45deg, rgba(255,255,255,.7) 0 5px, rgba(255,178,208,.55) 5px 11px)',
          quote: '纸页合上，梦却没有停',
          doodles: []
        },
        {
          id: 'p8', page: 8, type: 'story', chapter: '终', title: '未完待续', accent: '#ff7f9e',
          quote: '故事还长，我们慢慢讲',
          badgeBg: 'radial-gradient(circle at 35% 30%, #ffd7ea, #ff7f9e)',
          tapeA: 'repeating-linear-gradient(45deg, rgba(255,255,255,.7) 0 5px, rgba(255,178,208,.6) 5px 11px)',
          tapeB: 'repeating-linear-gradient(-45deg, rgba(255,255,255,.7) 0 5px, rgba(255,217,138,.6) 5px 11px)',
          photos: [
            { art: 'sunset', cap: '黄昏时分的约定', side: 'left', kind: 'circle', rot: 0, w: '42%' }
          ],
          paras: [
            '合上这一页的时候，夕阳刚好落在书脊上，把我们的影子拉得很长。',
            '谢谢你把这段时光交给我保管。所有的遇见都值得被好好收藏，就像这一页页，被你轻轻翻过。',
            '——那么，下一章，我们从哪里开始呢？'
          ],
          doodles: [
            { k: 'heart', left: '68%', top: '16%', rot: 8, size: 28 },
            { k: 'butterfly', left: '76%', top: '60%', rot: -12, size: 30 }
          ]
        }
      ]
    };
  },
  computed: {
    coverZ() {
      if (this.isOpen) return this.coverMoving ? 950 : 90;
      return 950;
    },
    burstSparks() {
      const list = [];
      for (let i = 0; i < 14; i++) {
        list.push({
          ang: (360 / 14) * i + Math.random() * 14,
          dist: 120 + Math.random() * 160,
          delay: Math.random() * 0.12
        });
      }
      return list;
    },
    bookStyle() {
      const p = Math.min(1, this.bookDeg / 84);
      return {
        transform: 'translate(-50%, -50%) rotateX(' + this.bookDeg.toFixed(2) + 'deg)',
        opacity: (1 - 0.1 * p).toFixed(3)
      };
    },
    charSinkStyle() {
      return {
        transform: 'translateY(' + (108 * this.charSink).toFixed(2) + '%)',
        opacity: (1 - this.charSink).toFixed(3)
      };
    }
  },
  created() {
    this.sparkles = this.makeSparks(14, 50);
    this.sceneSparks = this.makeSparks(12, 40);
    this.petals = this.makePetals(22);
    window.addEventListener('keydown', this.onKey);
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.onKey);
    if (this._sinkRaf) cancelAnimationFrame(this._sinkRaf);
    if (this._bookRaf) cancelAnimationFrame(this._bookRaf);
    clearTimeout(this._closeTimer);
    clearTimeout(this._leaveTimer);
  },
  methods: {
    makeSparks(n, maxSize) {
      const list = [];
      for (let i = 0; i < n; i++) {
        list.push({
          left: (2 + Math.random() * 92).toFixed(1) + '%',
          top: (4 + Math.random() * 88).toFixed(1) + '%',
          size: (8 + Math.random() * maxSize).toFixed(1),
          dur: (1.6 + Math.random() * 2.4).toFixed(2),
          delay: (Math.random() * 2.2).toFixed(2)
        });
      }
      return list;
    },
    makePetals(n) {
      const list = [];
      for (let i = 0; i < n; i++) {
        list.push({
          left: (Math.random() * 100).toFixed(1) + '%',
          size: (9 + Math.random() * 9).toFixed(1),
          dur: (7 + Math.random() * 9).toFixed(2),
          delay: (-Math.random() * 14).toFixed(2)
        });
      }
      return list;
    },
    onKey(e) {
      if (this.viewMode !== 'book') return;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') this.goNext();
      if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') this.goPrev();
    },
    leafCls(i) {
      const cls = [];
      if (i < this.currentIndex) cls.push('flipped');
      if (this.flipping && this.flipTarget === i) cls.push('turning');
      if (this.flipFast) cls.push('fast');
      return cls;
    },
    leafZ(i) {
      if (this.flipping && this.flipTarget === i) return 900;
      if (i < this.currentIndex) return 100 + i;
      return 600 - i;
    },
    openBook() {
      if (this.isOpen || this.viewMode !== 'book') return;
      this.isOpen = true;
      this.coverMoving = true;
      this.burst = true;
      const self = this;
      setTimeout(function () { self.coverMoving = false; }, 950);
      setTimeout(function () { self.burst = false; }, 1300);
    },
    closeBook() {
      if (!this.isOpen || this.flipping) return;
      this.isOpen = false;
      this.coverMoving = true;
      this.flipFast = true;
      this.flipping = true;
      this.currentIndex = 0;
      const self = this;
      setTimeout(function () { self.coverMoving = false; self.flipFast = false; self.flipping = false; self.flipTarget = -2; }, 1000);
    },
    goNext() {
      if (this.flipping || this.viewMode !== 'book') return;
      if (!this.isOpen) { this.openBook(); return; }
      // 翻过最后一页：书本合上，完成「翻页合书」
      if (this.currentIndex >= this.pages.length - 1) { this.closeBook(); return; }
      this.flipTarget = this.currentIndex;
      this.flipping = true;
      this.currentIndex++;
      const self = this;
      setTimeout(function () { self.flipping = false; self.flipTarget = -2; }, 900);
    },
    goPrev() {
      if (this.flipping || this.viewMode !== 'book') return;
      if (!this.isOpen) return;
      if (this.currentIndex === 0) { this.closeBook(); return; }
      this.currentIndex--;
      this.flipTarget = this.currentIndex;
      this.flipping = true;
      const self = this;
      setTimeout(function () { self.flipping = false; self.flipTarget = -2; }, 900);
    },
    jumpTo(i) {
      if (this.flipping || this.viewMode !== 'book' || !this.isOpen) return;
      if (i === this.currentIndex) return;
      const from = this.currentIndex;
      this.flipFast = true;
      this.flipping = true;
      this.flipTarget = i < from ? i : -2;
      this.jumpFlash = true;
      this.currentIndex = i;
      const self = this;
      setTimeout(function () {
        self.flipping = false;
        self.flipTarget = -2;
        self.flipFast = false;
        self.jumpFlash = false;
      }, 720);
    },
    goToc() {
      this.jumpTo(0);
    },
                    enterScene(from) {
      if (this.viewMode === 'scene' || this.toppling) return;
      this.sceneFrom = from;
      this.sceneLeaving = false;
      // book topples and chars rise at the same time
      this.toppling = true;
      this.charSink = 0;
      this.animateBook(0, 84, 900);
      this.sceneKey++;
      this.viewMode = 'scene';
    },
                    exitScene() {
      // chars sink & fade out while the book stands up slower (same time)
      if (this.viewMode !== 'scene' || this.sceneLeaving) return;
      this.sceneLeaving = true;
      this.animateSink(0, 1, 900);
      this.animateBook(84, 0, 1100);
      this.toppling = false;
      var self = this;
      clearTimeout(this._closeTimer);
      this._closeTimer = setTimeout(function () {
        self.viewMode = 'book';
      }, 900);
      clearTimeout(this._leaveTimer);
      this._leaveTimer = setTimeout(function () {
        self.sceneLeaving = false;
      }, 1450);
    },
    animateSink(fromP, toP, dur) {
      var self = this;
      var t0 = performance.now();
      if (this._sinkRaf) cancelAnimationFrame(this._sinkRaf);
      function tick(now) {
        var p = Math.min(1, (now - t0) / dur);
        var eased = 1 - Math.pow(1 - p, 3);
        self.charSink = fromP + (toP - fromP) * eased;
        if (p < 1) self._sinkRaf = requestAnimationFrame(tick);
      }
      this._sinkRaf = requestAnimationFrame(tick);
    },
    animateBook(fromDeg, toDeg, dur) {
      var self = this;
      var t0 = performance.now();
      if (this._bookRaf) cancelAnimationFrame(this._bookRaf);
      function tick(now) {
        var p = Math.min(1, (now - t0) / dur);
        var eased = 1 - Math.pow(1 - p, 3);
        self.bookDeg = fromDeg + (toDeg - fromDeg) * eased;
        if (p < 1) self._bookRaf = requestAnimationFrame(tick);
      }
      this._bookRaf = requestAnimationFrame(tick);
    }
  }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Ma+Shan+Zheng&family=Zhi+Mang+Xing&display=swap');

/* 页面外层：为固定头部导航栏让位 60px */
.ta-page {
  height: 100vh;
  padding-top: 60px;
  box-sizing: border-box;
  overflow: hidden;
}

.ta-root {
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 988px;
  overflow: hidden;
  perspective: 1600px;
  background:
    radial-gradient(120% 100% at 50% 28%, #fff4f9 0%, #ffe4f0 45%, #ffd2e6 100%);
  font-family: 'Ma Shan Zheng', 'Kaiti SC', 'STKaiti', 'KaiTi', '楷体', 'Comic Sans MS', cursive;
  user-select: none;
  -webkit-user-select: none;
}
.ta-root::before {
  content: '';
  position: absolute;
  inset: 0;
  pointer-events: none;
  background-image:
    radial-gradient(rgba(255, 255, 255, .85) 1px, transparent 1.8px),
    radial-gradient(rgba(255, 176, 214, .5) 1px, transparent 1.6px);
  background-size: 74px 74px, 110px 110px;
  background-position: 12px 18px, 46px 60px;
  opacity: .5;
}

/* ===================== 封面 ===================== */
.cover-closed {
  position: absolute;
  left: 50%;
  top: 50%;
  width: min(88vw, 1200px, calc(72vh * 1.45));
  height: min(72vh, 840px);
  transform: translate(-50%, -50%);
  z-index: 120;
  cursor: pointer;
  transition: transform .75s cubic-bezier(.6, .05, .3, 1), opacity .65s ease, filter .65s ease;
}
.cover-closed.opening {
  transform: translate(-60%, -54%) rotateY(-46deg) scale(.92);
  opacity: 0;
  filter: blur(4px);
  pointer-events: none;
}
.cover-float {
  position: absolute;
  inset: 0;
  animation: coverBob 5.5s ease-in-out infinite;
}
@keyframes coverBob {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-12px); }
}
.cover-art {
  position: absolute;
  inset: 0;
  border-radius: 18px 12px 12px 18px;
  background:
    radial-gradient(130% 140% at 28% 18%, #8b4fae 0%, #66308c 42%, #45206a 80%),
    repeating-linear-gradient(45deg, rgba(255, 255, 255, .035) 0 8px, transparent 8px 16px);
  box-shadow:
    inset 0 0 90px rgba(16, 4, 38, .55),
    inset 0 0 16px rgba(255, 218, 160, .22),
    0 30px 70px rgba(120, 40, 110, .45),
    0 6px 18px rgba(120, 40, 110, .3);
  overflow: hidden;
}
.cover-art::before {
  content: '';
  position: absolute;
  left: 10%;
  right: 10%;
  top: -30%;
  height: 70%;
  background: radial-gradient(60% 60% at 50% 50%, rgba(255, 200, 235, .28), transparent 70%);
  filter: blur(18px);
  pointer-events: none;
}
.cover-frame {
  position: absolute;
  inset: 15px;
  border: 2px solid rgba(255, 214, 150, .6);
  border-radius: 11px;
  box-shadow: inset 0 0 0 4px rgba(255, 214, 150, .1), inset 0 0 34px rgba(0, 0, 0, .28);
  pointer-events: none;
}
.cover-corner {
  position: absolute;
  top: 15px;
  left: 15px;
  width: 76px;
  height: 76px;
  transform: scale(1, 1);
}
.cover-corner g:nth-child(2) { display: none; }
.cover-emblem {
  position: absolute;
  top: 8%;
  left: 50%;
  width: min(34%, 250px);
  transform: translateX(-50%);
  filter: drop-shadow(0 6px 16px rgba(0, 0, 0, .4));
  animation: emblemPulse 4.2s ease-in-out infinite;
}
@keyframes emblemPulse {
  0%, 100% { transform: translateX(-50%) scale(1); filter: drop-shadow(0 6px 14px rgba(0, 0, 0, .35)); }
  50% { transform: translateX(-50%) scale(1.045); filter: drop-shadow(0 8px 22px rgba(255, 150, 210, .45)); }
}
.cover-title {
  position: absolute;
  left: 0;
  right: 0;
  top: 41%;
  margin: 0;
  text-align: center;
  font-family: 'Zhi Mang Xing', 'Ma Shan Zheng', cursive;
  font-size: clamp(36px, 4.8vw, 64px);
  font-weight: 400;
  letter-spacing: 6px;
  background: linear-gradient(100deg, #fde8b0, #ffcf7a 28%, #fff8e2 50%, #ffcf7a 72%, #fde8b0);
  background-size: 220% 100%;
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  animation: shine 5.5s linear infinite;
  filter: drop-shadow(0 3px 5px rgba(0, 0, 0, .4));
}
@keyframes shine {
  to { background-position: -220% 0; }
}
.cover-sub {
  position: absolute;
  left: 0;
  right: 0;
  top: 58%;
  margin: 0;
  text-align: center;
  color: rgba(255, 218, 235, .85);
  font-family: 'Ma Shan Zheng', cursive;
  font-size: clamp(13px, 1.4vw, 17px);
  letter-spacing: 5px;
}
.cover-hint {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 7%;
  margin: 0;
  text-align: center;
  color: #ffd9ea;
  font-size: clamp(14px, 1.5vw, 17px);
  letter-spacing: 3px;
  animation: hintPulse 2.4s ease-in-out infinite;
  text-shadow: 0 2px 8px rgba(0, 0, 0, .4);
}
@keyframes hintPulse {
  0%, 100% { opacity: .55; transform: scale(1); }
  50% { opacity: 1; transform: scale(1.05); }
}
.gem {
  position: absolute;
  width: 34px;
  height: 34px;
  background: radial-gradient(circle at 35% 30%, #fff3cf, #ffcf7a 55%, #d9a25a);
  clip-path: polygon(50% 0, 100% 38%, 78% 100%, 22% 100%, 0 38%);
  filter: drop-shadow(0 3px 8px rgba(0, 0, 0, .45));
  animation: gemPulse 3.6s ease-in-out infinite;
}
.gem::after {
  content: '';
  position: absolute;
  left: 30%;
  top: 16%;
  width: 22%;
  height: 26%;
  background: rgba(255, 255, 255, .85);
  transform: rotate(24deg);
  border-radius: 2px;
}
.gem-tl { top: 34px; left: 34px; }
.gem-tr { top: 34px; right: 34px; animation-delay: .6s; }
.gem-bl { bottom: 34px; left: 34px; animation-delay: 1.1s; }
.gem-br { bottom: 34px; right: 34px; animation-delay: 1.7s; }
@keyframes gemPulse {
  0%, 100% { transform: scale(1) rotate(-3deg); }
  50% { transform: scale(1.18) rotate(3deg); }
}
.cspark {
  position: absolute;
  color: #ffe3a8;
  text-shadow: 0 0 10px rgba(255, 210, 140, .9);
  pointer-events: none;
  animation: twinkle 2.2s ease-in-out infinite;
}
@keyframes twinkle {
  0%, 100% { opacity: .15; transform: scale(.7) rotate(0deg); }
  50% { opacity: 1; transform: scale(1.25) rotate(40deg); }
}

/* ===================== 魔法书主体 ===================== */
.ta-bookwrap {
  position: absolute;
  left: 50%;
  top: 50%;
  width: min(88vw, 1200px, calc(72vh * 1.45));
  height: min(72vh, 840px);
  transform-origin: 50% 100%;
  z-index: 20;
}
.ta-bookwrap.toppling {
  pointer-events: none;
}
.ta-book {
  position: absolute;
  inset: 0;
  perspective: 2400px;
}
.book-base {
  position: absolute;
  inset: 0;
  border-radius: 16px 12px 12px 16px;
  background: linear-gradient(160deg, #7c4a9e, #5a2d6e 58%, #42214f);
  box-shadow:
    inset 0 0 70px rgba(0, 0, 0, .38),
    0 28px 66px rgba(118, 48, 108, .4),
    0 8px 20px rgba(118, 48, 108, .25);
  z-index: 1;
}
.book-base::after {
  content: '';
  position: absolute;
  left: 50%;
  top: 0;
  bottom: 0;
  width: 4px;
  transform: translateX(-50%);
  background: linear-gradient(rgba(0, 0, 0, .4), rgba(0, 0, 0, .12) 30%, rgba(0, 0, 0, .42));
  border-radius: 2px;
}
.ta-book::before {
  content: '';
  position: absolute;
  top: 8px;
  bottom: -12px;
  right: -12px;
  width: 12px;
  background: linear-gradient(180deg, #fbe9f2, #e4c4d8 55%, #cda4c0);
  border-radius: 0 6px 6px 0;
  box-shadow: 2px 4px 10px rgba(90, 30, 80, .4);
  z-index: 2;
}
.ta-book::after {
  content: '';
  position: absolute;
  left: 10px;
  right: -12px;
  bottom: -12px;
  height: 12px;
  background: linear-gradient(90deg, #dcc0d2, #c49cba);
  border-radius: 0 0 6px 6px;
  z-index: 2;
}

/* ---- 书叶 ---- */
.ta-leaf {
  position: absolute;
  top: 0;
  left: 50%;
  width: 50%;
  height: 100%;
  transform-origin: left center;
  transform-style: preserve-3d;
  transition: transform .85s cubic-bezier(.55, .06, .3, .99);
  will-change: transform;
}
.ta-leaf.flipped { transform: rotateY(-180deg); }
.ta-leaf.fast { transition-duration: .42s; }
.face {
  position: absolute;
  inset: 0;
  overflow: hidden;
  backface-visibility: hidden;
  -webkit-backface-visibility: hidden;
}
.face.front { transform: rotateY(0deg); }
.face.back { transform: rotateY(180deg); }
.face.front {
  background: linear-gradient(155deg, #fffdf7, #fff4e6 60%, #ffeedd);
  box-shadow: inset 0 0 30px rgba(220, 170, 200, .18);
}
.face.front::after {
  content: '';
  position: absolute;
  inset: 0;
  background-image: radial-gradient(#f0cfe0 1px, transparent 1.5px);
  background-size: 17px 17px;
  opacity: .5;
  pointer-events: none;
}
.face.front::before {
  content: '';
  position: absolute;
  inset: 0;
  background: linear-gradient(to right, rgba(120, 50, 110, .17), transparent 26%);
  z-index: 2;
  pointer-events: none;
}
.face.back {
  background: linear-gradient(155deg, #fdf3e8, #fae6d6);
  box-shadow: inset 0 0 30px rgba(210, 160, 130, .2);
}
.face.back::before {
  content: '';
  position: absolute;
  inset: 0;
  background: linear-gradient(to left, rgba(120, 50, 110, .17), transparent 26%);
  z-index: 2;
  pointer-events: none;
}
.flip-shade {
  position: absolute;
  inset: 0;
  z-index: 5;
  pointer-events: none;
  background: linear-gradient(to right, rgba(84, 22, 72, .3), rgba(84, 22, 72, .1) 42%, transparent 66%);
  opacity: 0;
  transition: opacity .3s ease;
}
.ta-leaf.turning .flip-shade { opacity: 1; }

/* ---- 页面内容 ---- */
.page {
  position: relative;
  z-index: 3;
  height: 100%;
  box-sizing: border-box;
  padding: clamp(24px, 3.6vh, 40px) clamp(20px, 2.6vw, 34px);
}
.tape {
  position: absolute;
  width: 92px;
  height: 24px;
  border-radius: 2px;
  opacity: .8;
  box-shadow: 0 2px 5px rgba(120, 50, 90, .16);
  pointer-events: none;
  z-index: 6;
}
.tape::before, .tape::after {
  content: '';
  position: absolute;
  top: 0;
  width: 0;
  height: 0;
  border-top: 12px solid rgba(120, 60, 90, .16);
  border-bottom: 12px solid transparent;
}
.tape::before { left: 0; border-right: 9px solid transparent; }
.tape::after { right: 0; border-left: 9px solid transparent; }
.tp-a { top: 14px; left: -16px; transform: rotate(-38deg); }
.tp-b { top: 12px; right: -14px; transform: rotate(34deg); }

.page-head {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 14px;
}
.chapter-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: clamp(36px, 4.2vh, 46px);
  height: clamp(36px, 4.2vh, 46px);
  border-radius: 50%;
  color: #fff;
  font-size: clamp(16px, 2.2vh, 21px);
  box-shadow: 0 4px 12px rgba(228, 104, 168, .4), inset 0 1px 2px rgba(255, 255, 255, .7);
  flex-shrink: 0;
}
.page-title {
  margin: 0;
  font-family: 'Zhi Mang Xing', 'Ma Shan Zheng', cursive;
  font-size: clamp(24px, 3.4vh, 34px);
  font-weight: 400;
  letter-spacing: 3px;
  text-decoration: underline wavy rgba(243, 169, 198, .85) 1.5px;
  text-underline-offset: 6px;
  text-shadow: 0 2px 0 rgba(255, 255, 255, .9);
}

.page-body { position: relative; }
.photo {
  position: relative;
  background: #fffdf8;
  padding: 9px 9px 32px;
  border-radius: 3px;
  box-shadow: 0 9px 22px rgba(150, 70, 110, .24), 0 2px 5px rgba(150, 70, 110, .14);
  transform: rotate(var(--rot));
  transition: transform .35s ease, box-shadow .35s ease;
  cursor: zoom-in;
  margin: 8px 0 6px;
}
.photo.left { float: left; margin-right: 20px; }
.photo.right { float: right; margin-left: 20px; }
.photo:hover {
  transform: rotate(0deg) translateY(-6px) scale(1.045);
  box-shadow: 0 16px 34px rgba(160, 70, 120, .34);
}
.photo.pop { animation: photoPop .55s ease; }
@keyframes photoPop {
  0% { transform: rotate(var(--rot)) scale(1); }
  40% { transform: rotate(var(--rot)) scale(1.16) rotate(-3deg); }
  100% { transform: rotate(var(--rot)) scale(1); }
}
.photo::before {
  content: '';
  position: absolute;
  top: -11px;
  left: 50%;
  transform: translateX(-50%) rotate(-2deg);
  width: 88px;
  height: 24px;
  background: repeating-linear-gradient(45deg, rgba(255, 255, 255, .78) 0 6px, rgba(255, 196, 216, .6) 6px 12px);
  box-shadow: 0 1px 3px rgba(0, 0, 0, .14);
  z-index: 2;
}
.photo .art { display: block; border-radius: 2px; overflow: hidden; line-height: 0; }
.photo .art svg { width: 100%; height: auto; }
.photo .cap {
  position: absolute;
  left: 4px;
  right: 4px;
  bottom: 7px;
  text-align: center;
  font-size: 12.5px;
  color: #b06a8c;
  letter-spacing: 1px;
}
.photo.circle {
  border-radius: 50%;
  padding: 0;
  width: min(44%, 210px) !important;
  height: auto;
  aspect-ratio: 1;
  shape-outside: circle(50%);
  shape-margin: 18px;
  margin: 12px 0 8px;
}
.photo.circle.left { margin-right: 24px; }
.photo.circle.right { margin-left: 24px; }
.photo.circle .art { border-radius: 50%; }
.photo.circle .cap { display: none; }
.photo.circle::before { display: none; }
.photo.circle:hover { border-radius: 50%; }

.page-text p {
  margin: 0 0 12px;
  font-size: clamp(14.5px, 2.05vh, 17px);
  line-height: 1.9;
  color: #6d4460;
  text-align: justify;
  text-indent: 2em;
  letter-spacing: .6px;
}
.page-foot {
  position: absolute;
  left: clamp(20px, 2.6vw, 34px);
  right: clamp(20px, 2.6vw, 34px);
  bottom: 14px;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
}
.foot-quote {
  font-size: clamp(12px, 1.6vh, 14.5px);
  opacity: .85;
  letter-spacing: 1px;
}
.page-num {
  font-family: 'Zhi Mang Xing', 'Ma Shan Zheng', cursive;
  font-size: clamp(30px, 4.4vh, 44px);
  opacity: .5;
  line-height: 1;
}

/* ---- 背面 ---- */
.reverse {
  position: relative;
  z-index: 3;
  height: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 24px;
  text-align: center;
}
.rev-flower { width: 64px; opacity: .55; }
.rev-title {
  font-family: 'Zhi Mang Xing', 'Ma Shan Zheng', cursive;
  font-size: clamp(18px, 2.6vh, 24px);
  letter-spacing: 3px;
}
.rev-quote {
  font-size: clamp(11.5px, 1.6vh, 13.5px);
  color: #a98390;
  max-width: 80%;
}
.rev-num {
  font-family: 'Zhi Mang Xing', cursive;
  font-size: clamp(26px, 3.8vh, 36px);
  opacity: .5;
}
.rev-note {
  position: absolute;
  bottom: 18px;
  font-size: clamp(10.5px, 1.4vh, 12.5px);
  color: #c49aae;
  letter-spacing: 2px;
}

/* ---- 小涂鸦 ---- */
.doodle {
  position: absolute;
  z-index: 2;
  opacity: .8;
  pointer-events: none;
  line-height: 0;
  animation: doodleFloat 5.5s ease-in-out infinite;
}
.doodle svg { width: 100%; height: auto; }
@keyframes doodleFloat {
  0%, 100% { translate: 0 0; }
  50% { translate: 0 -6px; }
}

/* ---- 目录 ---- */
.toc {
  position: relative;
  z-index: 3;
  height: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: clamp(22px, 3.4vh, 38px) clamp(18px, 2.2vw, 30px);
  background: linear-gradient(155deg, #fffdf7, #fff3e3);
}
.toc-kicker {
  font-size: clamp(11px, 1.5vh, 13px);
  color: #d98ab8;
  letter-spacing: 4px;
}
.toc-title {
  margin: 2px 0 6px;
  font-family: 'Zhi Mang Xing', 'Ma Shan Zheng', cursive;
  font-weight: 400;
  font-size: clamp(26px, 4.2vh, 38px);
  color: #b03a72;
  letter-spacing: 10px;
  text-shadow: 0 2px 0 #fff;
}
.toc-line {
  display: block;
  width: 70%;
  height: 1.5px;
  background: linear-gradient(90deg, transparent, #f3a9c6, transparent);
  margin-bottom: 12px;
}
.toc-list {
  list-style: none;
  margin: 0;
  padding: 0;
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
}
.toc-list li {
  display: flex;
  align-items: center;
  gap: 9px;
  padding: 8px 12px;
  border-radius: 12px;
  cursor: pointer;
  transition: transform .28s ease, background .28s ease, box-shadow .28s ease;
}
.toc-list li:hover {
  transform: translateX(6px) scale(1.02);
  background: rgba(255, 214, 235, .45);
  box-shadow: 0 4px 14px rgba(230, 120, 175, .22);
}
.toc-num {
  font-family: 'Zhi Mang Xing', cursive;
  font-size: clamp(13px, 1.8vh, 16px);
  width: 26px;
  flex-shrink: 0;
}
.toc-icon { width: 21px; height: 21px; flex-shrink: 0; line-height: 0; }
.toc-icon svg { width: 100%; height: 100%; }
.toc-name {
  font-size: clamp(13px, 1.9vh, 16px);
  color: #6d4460;
  letter-spacing: 1px;
  white-space: nowrap;
}
.toc-dots {
  flex: 1;
  border-bottom: 2px dotted rgba(214, 150, 190, .7);
  margin: 0 3px;
  transform: translateY(-3px);
}
.toc-page {
  font-family: 'Ma Shan Zheng', cursive;
  font-size: clamp(11.5px, 1.6vh, 13.5px);
  color: #b06a8c;
  flex-shrink: 0;
}
.toc-hint {
  margin: 6px 0 0;
  font-size: clamp(11px, 1.5vh, 13px);
  color: #c49aae;
  letter-spacing: 3px;
  animation: hintPulse 2.6s ease-in-out infinite;
}

/* ---- 立绘页 ---- */
.art-page {
  position: relative;
  display: flex;
  align-items: flex-start;
  gap: clamp(10px, 1.6vw, 20px);
  margin-top: 6px;
}
.art-card {
  position: relative;
  flex-shrink: 0;
  width: 46%;
  padding: clamp(5px, 0.7vh, 8px) clamp(5px, 0.7vh, 8px) clamp(24px, 3.2vh, 30px);
  background: linear-gradient(160deg, #fffdfb, #ffeaf3);
  border: 1px solid rgba(255, 183, 214, .85);
  border-radius: clamp(8px, 1.2vh, 12px);
  box-shadow: 0 10px 22px rgba(220, 120, 175, .32);
  transform: rotate(-1.6deg);
  line-height: 0;
}
.art-card img {
  width: 100%;
  height: auto;
  display: block;
  border-radius: clamp(4px, 0.6vh, 6px);
}
.art-cards {
  display: flex;
  gap: clamp(8px, 1.2vw, 14px);
  width: 60%;
  flex-shrink: 0;
  align-items: flex-start;
}
.art-cards .art-card { width: 50%; transform: rotate(1.2deg); }
.art-cards .art-card:first-child { transform: rotate(-1.6deg); }
.ac-label {
  position: absolute;
  left: 0;
  right: 0;
  bottom: clamp(5px, 0.7vh, 8px);
  text-align: center;
  font-family: 'Zhi Mang Xing', 'Ma Shan Zheng', cursive;
  font-size: clamp(13px, 1.9vh, 16px);
  letter-spacing: 2px;
  color: #b0527f;
  line-height: 1.2;
  pointer-events: none;
}
.art-info { flex: 1; padding-top: 4px; }
.art-name {
  margin: 0 0 8px;
  font-family: 'Zhi Mang Xing', 'Ma Shan Zheng', cursive;
  font-weight: 400;
  font-size: clamp(20px, 3vh, 27px);
  color: #a12f6d;
  letter-spacing: 2px;
}
.art-desc {
  margin: 0 0 10px;
  font-size: clamp(13.5px, 1.9vh, 15.5px);
  line-height: 1.85;
  color: #7c5068;
  text-align: justify;
}
.art-tags {
  list-style: none;
  margin: 0 0 14px;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
}
.art-tags li {
  padding: 4px 12px;
  border-radius: 999px;
  background: rgba(255, 214, 235, .7);
  border: 1px solid rgba(240, 150, 195, .5);
  color: #b0527f;
  font-size: clamp(11px, 1.5vh, 13px);
}
.art-btn {
  border: none;
  cursor: pointer;
  padding: 11px 22px;
  border-radius: 999px;
  color: #fff;
  font-family: 'Ma Shan Zheng', 'KaiTi', cursive;
  font-size: clamp(14px, 2vh, 17px);
  letter-spacing: 3px;
  background: radial-gradient(circle at 35% 30%, #ffc2de, #ff7fb4 60%, #e9689e);
  box-shadow: 0 8px 22px rgba(230, 110, 170, .45), inset 0 1px 2px rgba(255, 255, 255, .7);
  transition: transform .3s ease, box-shadow .3s ease;
  animation: artBtnGlow 2.8s ease-in-out infinite;
}
.art-btn:hover {
  transform: translateY(-3px) scale(1.05);
  box-shadow: 0 14px 30px rgba(230, 110, 170, .6), inset 0 1px 2px rgba(255, 255, 255, .7);
}
.art-btn:active { transform: scale(.95); }
@keyframes artBtnGlow {
  0%, 100% { box-shadow: 0 8px 22px rgba(230, 110, 170, .4); }
  50% { box-shadow: 0 8px 32px rgba(255, 150, 200, .75); }
}
.ab-spark { display: inline-block; animation: abTw 1.6s ease-in-out infinite; }
.ab-spark:last-child { animation-delay: .4s; }
@keyframes abTw {
  0%, 100% { transform: scale(1) rotate(0); opacity: .7; }
  50% { transform: scale(1.5) rotate(90deg); opacity: 1; }
}
.art-foot {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 18px;
  text-align: center;
  font-size: clamp(11px, 1.5vh, 13px);
  color: #c49aae;
  letter-spacing: 3px;
}

/* ---- 封面内页 ---- */
.cover-inner-face {
  position: relative;
  z-index: 3;
  height: 100%;
  background: linear-gradient(155deg, #fdf6ee, #fbe8d9);
}
.ci-ornament {
  position: absolute;
  top: 10px;
  left: 10px;
  width: 72px;
  opacity: .7;
}

/* ---- 导航 ---- */
.nav-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 46px;
  height: 46px;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  color: #8a2f68;
  font-size: 24px;
  line-height: 1;
  z-index: 150;
  background: radial-gradient(circle at 35% 30%, #fff0f7, #f7b7d6 60%, #ef8fc0);
  box-shadow: 0 6px 18px rgba(190, 80, 140, .35), inset 0 1px 2px rgba(255, 255, 255, .8);
  transition: transform .25s ease, box-shadow .25s ease, opacity .25s ease;
  font-family: 'Ma Shan Zheng', cursive;
}
.nav-btn:hover { transform: translateY(-50%) scale(1.14); box-shadow: 0 10px 28px rgba(190, 80, 140, .5); }
.nav-btn:active { transform: translateY(-50%) scale(.92); }
.nav-prev { left: 14px; }
.nav-next { right: 14px; }
.nav-toc {
  left: calc(50% - 86px);
  top: 14px;
  transform: translateX(-50%);
  width: auto;
  height: auto;
  padding: 7px 18px;
  border-radius: 999px;
  font-size: 14px;
  letter-spacing: 2px;
}
.nav-close {
  left: calc(50% + 86px);
  top: 14px;
  transform: translateX(-50%);
  width: auto;
  height: auto;
  padding: 7px 16px;
  border-radius: 999px;
  font-size: 14px;
  letter-spacing: 2px;
}
.nav-toc:hover, .nav-close:hover { transform: translateX(-50%) scale(1.08); }
.nav-toc:active, .nav-close:active { transform: translateX(-50%) scale(.94); }
.nav-btn.disabled { opacity: .35; cursor: default; pointer-events: none; }

/* ---- 跳转闪光 ---- */
.ta-flash {
  position: absolute;
  inset: 0;
  z-index: 130;
  pointer-events: none;
  opacity: 0;
  background: radial-gradient(circle at 50% 50%, rgba(255, 236, 248, .95), rgba(255, 190, 225, .6) 42%, transparent 75%);
}
.ta-flash.on {
  animation: flashFx .6s ease-out forwards;
}
@keyframes flashFx {
  0% { opacity: 0; }
  18% { opacity: 1; }
  100% { opacity: 0; }
}

/* ---- 翻开星光迸发 ---- */
.fx-burst {
  position: absolute;
  left: 50%;
  top: 50%;
  z-index: 140;
  pointer-events: none;
}
.fx-burst span {
  position: absolute;
  left: 0;
  top: 0;
  color: #ffe0a0;
  font-size: 22px;
  text-shadow: 0 0 12px rgba(255, 200, 130, .95);
  animation: burstFly 1.05s cubic-bezier(.2, .6, .35, 1) forwards;
  opacity: 0;
}
@keyframes burstFly {
  0% { opacity: 0; transform: translate(0, 0) scale(.4) rotate(0); }
  16% { opacity: 1; }
  100% { opacity: 0; transform: translate(calc(cos(var(--ang)) * var(--dist)), calc(sin(var(--ang)) * var(--dist))) scale(1.15) rotate(140deg); }
}

/* ===================== 立绘魔法场景 ===================== */
.ta-scene {
  position: absolute;
  inset: 0;
  z-index: 60;
  overflow: hidden;
  background: transparent;
  isolation: isolate;
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transition: opacity 0.42s ease, visibility 0s linear 0.42s;
}
.ta-scene.scene-show {
  opacity: 1;
  visibility: visible;
  pointer-events: auto;
  transition: opacity 0.42s ease;
  animation: blossom-fade 0.8s ease both;
}
.scene-inner {
  position: absolute;
  inset: 0;
}
@keyframes blossom-fade {
  from { opacity: 0; transform: scale(1.06); }
  to { opacity: 1; transform: scale(1); }
}
.fade-enter-active { transition: opacity .42s ease; }
.fade-enter { opacity: 0; }
.fade-leave-active { transition: opacity .42s ease .18s; }
.fade-leave-to { opacity: 0; }

/* 鎭㈠锛氬簳搴т笌绔嬬粯鍓焊娌夊洖涔﹀簳 */
.ta-scene.leaving .char-rise {
  animation: none;
}
.ta-scene.leaving .scene-ground {
  animation: none;
  transform: scale(0.9);
  opacity: 0;
  transition: transform 0.8s ease, opacity 0.8s ease;
}
.ta-scene.leaving .char::after {
  opacity: 0;
  transition: opacity 0.6s ease 0.15s;
}
.ta-scene.leaving .scene-tree {
  animation: none;
  opacity: 0;
  transition: opacity 0.85s ease;
}
.ta-scene.leaving .scene-sky-img,
.ta-scene.leaving .scene-sky-tint {
  animation: none;
  opacity: 0;
  transition: opacity 0.7s ease .1s;
}
.ta-scene.leaving .scene-glow-orb {
  animation: none;
  opacity: 0;
  transition: opacity 0.6s ease;
}
.ta-scene.leaving .scene-petals,
.ta-scene.leaving .sspark {
  opacity: 0;
  transition: opacity 0.6s ease;
}
.ta-scene.leaving .scene-back {
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.3s ease;
}
@keyframes skyIn {
  0% { opacity: 0; }
  100% { opacity: 1; }
}

.scene-sky-img {
  position: absolute;
  inset: 0;
  background-size: cover;
  background-position: center;
  z-index: 0;
  animation: skyIn 0.8s ease .05s both;
}
.scene-sky-tint {
  position: absolute;
  inset: 0;
  z-index: 1;
  background: linear-gradient(180deg, rgba(255, 170, 210, .14), rgba(255, 224, 238, .12) 45%, rgba(255, 205, 230, .28));
  pointer-events: none;
  animation: skyIn 0.7s ease .2s both;
}
.scene-glow-orb {
  position: absolute;
  border-radius: 50%;
  filter: blur(34px);
  opacity: .55;
  pointer-events: none;
  animation: orbFloat 7s ease-in-out infinite, skyIn 0.8s ease .3s both;
  z-index: 2;
}
.scene-glow-orb.o1 {
  width: clamp(220px, 30vh, 360px);
  height: clamp(220px, 30vh, 360px);
  left: 6%;
  top: 8%;
  background: radial-gradient(circle, rgba(255, 255, 255, .6), rgba(255, 190, 220, .28) 58%, transparent 78%);
}
.scene-glow-orb.o2 {
  width: clamp(180px, 24vh, 300px);
  height: clamp(180px, 24vh, 300px);
  right: 5%;
  bottom: 24%;
  background: radial-gradient(circle, rgba(255, 245, 200, .5), rgba(255, 205, 225, .25) 60%, transparent 80%);
  animation-delay: -3s;
}
@keyframes orbFloat {
  0%, 100% { transform: translateY(0) scale(1); }
  50% { transform: translateY(-16px) scale(1.07); }
}

.scene-tree {
  position: absolute;
  left: 1%;
  bottom: 30%;
  width: min(52%, 560px);
  z-index: 4;
  transform-origin: bottom center;
  animation: treeSway 9s ease-in-out infinite alternate, treeIn 0.9s ease .5s both;
  pointer-events: none;
}
.scene-tree img { width: 100%; height: auto; display: block; mix-blend-mode: multiply; }
@keyframes treeSway {
  from { transform: rotate(-1.4deg); }
  to { transform: rotate(1.4deg); }
}
@keyframes treeIn {
  0% { opacity: 0; }
  100% { opacity: 1; }
}

.char-zone {
  position: absolute;
  inset: 0;
  z-index: 5;
}
.char {
  position: absolute;
  bottom: 31%;
  transform-origin: bottom center;
}
.char::after {
  content: '';
  position: absolute;
  left: 50%;
  bottom: -20px;
  transform: translateX(-50%);
  width: 74%;
  height: 24px;
  background: radial-gradient(ellipse at center, rgba(122, 48, 100, .42), transparent 70%);
  border-radius: 50%;
}
.char-rise {
  height: 100%;
  transform: translateY(0);
  animation: girls-rise 1.35s cubic-bezier(0.2, 0.6, 0.25, 1) 0.35s both;
}
.char.lolita .char-rise { animation-delay: 0.35s; }
.char.jk .char-rise { animation-delay: 0.5s; }
.char.hanfu .char-rise { animation-delay: 0.65s; }
.char-inner {
  height: 100%;
  animation: charY 4.6s ease-in-out infinite;
  line-height: 0;
}
.char-inner img {
  height: 100%;
  width: auto;
  mix-blend-mode: multiply;
}
.char.lolita {
  left: 13%;
  height: min(56%, 460px);
  animation: charX 7s ease-in-out infinite;
}
.char.jk {
  left: 39%;
  height: min(48%, 400px);
  animation: charX 8.5s ease-in-out .8s infinite;
}
.char.hanfu {
  left: 62%;
  height: min(62%, 520px);
  animation: charX 9s ease-in-out 1.6s infinite;
}
.char.focus .char-inner { animation-duration: 3.8s; }
.char.focus .char-inner img { filter: brightness(1.07) saturate(1.1); }
@keyframes charX {
  0%, 100% { transform: translateX(-9px); }
  50% { transform: translateX(9px); }
}
@keyframes charY {
  0%, 100% { transform: translateY(0) rotate(-1.2deg); }
  50% { transform: translateY(-20px) rotate(1.2deg); }
}
@keyframes girls-rise {
  from { transform: translateY(104%); }
  to { transform: translateY(0); }
}
remove girls-sink
@keyframes base-grow {
  from { transform: scale(0.3); opacity: 0; }
  55% { opacity: 1; }
  to { transform: scale(1); opacity: 1; }
}
@keyframes base-fade {
  from { opacity: 1; transform: scale(1); }
  to { opacity: 0; transform: scale(0.9); }
}

.scene-ground {
  position: absolute;
  left: 4%;
  right: 4%;
  bottom: -9%;
  height: 33%;
  transform: scale(1);
  transform-origin: bottom center;
  animation: base-grow 1.05s cubic-bezier(0.22, 0.68, 0.3, 1) both;
  border-radius: 130px 130px 0 0;
  background: linear-gradient(180deg, #e9c9ef 0%, #c69ad6 46%, #9661ad 100%);
  box-shadow: 0 -8px 34px rgba(150, 60, 140, .4), inset 0 10px 26px rgba(255, 235, 245, .25);
}
.scene-ground::before {
  content: '';
  position: absolute;
  left: 50%;
  top: 4%;
  bottom: 16%;
  width: 2.5px;
  background: linear-gradient(rgba(90, 40, 90, .35), rgba(90, 40, 90, .18));
}
.scene-ground::after {
  content: '';
  position: absolute;
  left: 6%;
  right: 6%;
  top: 5%;
  bottom: 15%;
  border: 2.5px solid rgba(255, 215, 160, .6);
  border-radius: 100px 100px 0 0;
}
.ground-title {
  position: absolute;
  left: 50%;
  top: 8%;
  transform: translateX(-50%);
  color: rgba(255, 240, 250, .85);
  font-size: clamp(12px, 1.8vh, 16px);
  letter-spacing: 4px;
  text-shadow: 0 2px 6px rgba(120, 40, 110, .35);
}

.scene-petals { position: absolute; inset: 0; pointer-events: none; z-index: 7; }
.petal {
  position: absolute;
  top: -26px;
  object-fit: fill;
  mix-blend-mode: multiply;
  opacity: .95;
  animation: petalFall linear infinite;
}
@keyframes petalFall {
  0% { transform: translate3d(0, -6vh, 0) rotate(0deg); }
  25% { transform: translate3d(16px, 24vh, 0) rotate(70deg); }
  50% { transform: translate3d(-12px, 52vh, 0) rotate(150deg); }
  75% { transform: translate3d(18px, 78vh, 0) rotate(220deg); }
  100% { transform: translate3d(0, 112vh, 0) rotate(310deg); }
}
.sspark {
  position: absolute;
  color: #ff9ec9;
  text-shadow: 0 0 12px rgba(255, 170, 210, .95);
  pointer-events: none;
  animation: twinkle 2.4s ease-in-out infinite;
}
.scene-back {
  position: absolute;
  top: 18px;
  right: 20px;
  z-index: 10;
  border: none;
  cursor: pointer;
  padding: 10px 22px;
  border-radius: 999px;
  font-family: 'Ma Shan Zheng', 'KaiTi', cursive;
  font-size: clamp(14px, 2vh, 17px);
  letter-spacing: 2px;
  color: #8a2f68;
  background: rgba(255, 255, 255, .65);
  backdrop-filter: blur(8px);
  box-shadow: 0 6px 20px rgba(190, 80, 140, .3), inset 0 1px 2px rgba(255, 255, 255, .9);
  transition: transform .3s ease, box-shadow .3s ease;
}
.scene-back:hover { transform: translateY(-3px) scale(1.06); box-shadow: 0 12px 30px rgba(190, 80, 140, .45); }
.scene-back:active { transform: scale(.94); }
.sb-ic { margin-right: 4px; }
</style>
